// extracted by mini-css-extract-plugin
export default {"root":"LktBq","mobile":"sz5DQ","smallMobile":"EJzzK","tablet":"jshGZ"};